module.exports = __webpack_public_path__ + "img/stop_btn.45aa6bed.png";